/**
 * @generated SignedSource<<7aefa3edf8ffb6be09721e95e3d6b092>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppClipTabContainer_brand$data = {
  readonly appConfig: {
    readonly id: string;
    readonly iosAppClipsEnabled: boolean;
  };
  readonly id: string;
  readonly " $fragmentType": "AppClipTabContainer_brand";
};
export type AppClipTabContainer_brand$key = {
  readonly " $data"?: AppClipTabContainer_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppClipTabContainer_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppClipTabContainer_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iosAppClipsEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "7f865485128e2652d7449b50993148f3";

export default node;
